import { render, staticRenderFns } from "./lookupresult.vue?vue&type=template&id=780d3d9a&"
import script from "./lookupresult.vue?vue&type=script&lang=js&"
export * from "./lookupresult.vue?vue&type=script&lang=js&"
import style0 from "./lookupresult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports